import { displayPriceText } from "../../data/catalog";
import useOverlay from "../../hooks/useOverlay";
import { itemPath } from "../../routes";
import { asset } from "../../utils/format";

export default function ItemCard({ item, showStock = true }) {
  const { open } = useOverlay();
  const view = () => open(itemPath(item.id));

  return (
    <article
      className="card"
      role="button"
      tabIndex={0}
      aria-label={`View details for ${item.name}`}
      onClick={view}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          view();
        }
      }}
    >
      <div className="pic">
        <img loading="lazy" src={asset(item.image)} alt={item.name} />
      </div>
      <div className="body">
        <div className="price">{displayPriceText(item, true)}</div>
        <div className="name">{item.name}</div>
        {showStock && item.inStock === false && <div className="stockOut">Out of stock</div>}
        {showStock && item.inStock !== false && item.priceUnset && <div className="priceNeeded">Price needed before ordering</div>}
      </div>
    </article>
  );
}
